import { validatenull } from "@/echart/util";
import { validatenull2 } from "./validate";
import refreshTime from "../config/refreshTime.js";
import { setStore, getStore, removeStore } from "@/utils/store";
export const uuid = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
};
export const createFile = () => {
  return {
    title: "文件夹",
    name: "文件夹",
    index: uuid(),
    children: [],
  };
};
export const compare = (propertyName) => {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];
    if (value2 < value1) {
      return -1;
    } else if (value2 > value1) {
      return 1;
    } else {
      return 0;
    }
  };
};

export const funEval = (value) => {
  return new Function("return " + value + ";")();
};

export const getFunction = (fun, def) => {
  if (!validatenull(fun)) {
    try {
      return funEval(fun);
    } catch {
      return () => {};
    }
  } else if (def) return () => {};
};
export const getJson = (str) => {
  if (validatenull(str)) return {};
  else if (typeof str == "string") {
    try {
      return JSON.parse(str);
    } catch {
      return {};
    }
  } else {
    return str;
  }
};
export const checkUrl = (url) => {
  var reg = /http(s)?:\/\/([\w-.]+)+(:[0-9]+)?.*$/;
  if (!reg.test(url)) {
    return false;
  } else {
    return true;
  }
};

export const checkYzfcApi = (url) => {
  var reg = /yzfcapi/;
  if (!reg.test(url)) {
    return false;
  } else {
    return true;
  }
};

/**
 * 从 userInfo 安全取角色字符串（兼容 role_name 与 roles 数组，以及 userInfo 为空/[]）
 * @param {Object|Array} userInfo - store 的 userInfo
 * @returns {string}
 */
export const getRoleName = (userInfo) => {
  if (!userInfo || typeof userInfo !== 'object' || Array.isArray(userInfo)) {
    return '';
  }
  if (userInfo.role_name != null && typeof userInfo.role_name === 'string') {
    return userInfo.role_name;
  }
  if (Array.isArray(userInfo.roles) && userInfo.roles.length) {
    return userInfo.roles.join(',');
  }
  return '';
};

/**
 * 判断 userInfo 是否包含某角色
 * @param {Object|Array} userInfo - store 的 userInfo
 * @param {string} roleName - 角色名，如 'administrator'
 * @returns {boolean}
 */
export const hasRole = (userInfo, roleName) => {
  return getRoleName(userInfo).indexOf(roleName) >= 0;
};

export const checkVisualApi = (url) => {
  var reg = /visualapi/;
  if (!reg.test(url)) {
    return false;
  } else {
    return true;
  }
};

export const checkColor = (isExceed) => {
  const NORMAL_COLOR = "#ffffff";
  // const MIN_COLOR = "#15E2FA";
  const EXCEED_COLOR = "#EC2A1E";
  let fontColor = NORMAL_COLOR;
  if (isExceed == 1) {
    fontColor = EXCEED_COLOR;
  } else {
    fontColor = NORMAL_COLOR;
  }
  return fontColor;
  const config = {
    DO: {
      min: 5,
      max: 10,
    },
    PH: {
      min: 6.5,
      max: 9.5,
    },
    TEMP: {
      min: 25,
      max: 30,
    },
    LIQUID: {
      min: 40,
      max: 2000,
    },
  };
  switch (type) {
    case "DO":
      return value == 0
        ? NORMAL_COLOR
        : value < config.DO.min
        ? MIN_COLOR
        : config.DO.min <= value && value <= config.DO.max
        ? NORMAL_COLOR
        : value > config.DO.max
        ? MAX_COLOR
        : NORMAL_COLOR;
    case "PH":
      return value == 0
        ? NORMAL_COLOR
        : value < config.PH.min
        ? MIN_COLOR
        : config.PH.min <= value && value <= config.PH.max
        ? NORMAL_COLOR
        : value > config.PH.max
        ? MAX_COLOR
        : NORMAL_COLOR;
    case "TEMP":
      return value == 0
        ? NORMAL_COLOR
        : value < config.TEMP.min
        ? MIN_COLOR
        : config.DO.min <= value && value <= config.TEMP.max
        ? NORMAL_COLOR
        : value > config.TEMP.max
        ? MAX_COLOR
        : NORMAL_COLOR;
    case "LIQUID":
      return value == 0
        ? NORMAL_COLOR
        : value < config.LIQUID.min
        ? MIN_COLOR
        : config.LIQUID.min <= value && value <= config.LIQUID.max
        ? NORMAL_COLOR
        : value > config.LIQUID.max
        ? MAX_COLOR
        : NORMAL_COLOR;
  }
};

export const deepClone = (data) => {
  var type = getObjType(data);
  var obj;
  if (type === "array") {
    obj = [];
  } else if (type === "object") {
    obj = {};
  } else {
    //不再具有下一层次
    return data;
  }
  if (type === "array") {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === "object") {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};

export const encryption = (params) => {
  let { data, type, param, key } = params;
  let result = JSON.parse(JSON.stringify(data));
  if (type == "Base64") {
    param.forEach((ele) => {
      result[ele] = btoa(result[ele]);
    });
  } else if (type == "Aes") {
    param.forEach((ele) => {
      result[ele] = window.CryptoJS.AES.encrypt(result[ele], key).toString();
    });
  }
  return result;
};

/**
 * 获取顶部地址栏地址
 */
export const getTopUrl = () => {
  return window.location.href.split("/#/")[0];
};

/**
 * 格式化日期时间为展示字符串（用于大屏等展示）
 * @param {Date|number|string} value - 日期对象、时间戳(毫秒)或日期字符串
 * @param {string} format - 格式，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string}
 */
export const formatDisplayDateTime = (value, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (value == null || value === '') return '--';
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '--';
  const pad = (n) => String(n).padStart(2, '0');
  const Y = date.getFullYear();
  const M = pad(date.getMonth() + 1);
  const D = pad(date.getDate());
  const h = pad(date.getHours());
  const m = pad(date.getMinutes());
  const s = pad(date.getSeconds());
  return format
    .replace('YYYY', Y)
    .replace('MM', M)
    .replace('DD', D)
    .replace('HH', h)
    .replace('mm', m)
    .replace('ss', s);
};

/**
 * 获取url参数
 * @param name 参数名
 */
export const getQueryString = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(decodeURI(r[2]));
  return null;
};

//水泵进出水压力显示颜色判断
export const getPressureColor = (value) => {
  const min = 1500;
  const max = 2500;
  if (value < min || value > max) {
    //红色
    return "#EC2D1D ";
  } else if (value > min && value <= max) {
    //绿色
    return "#00D355";
  } else if (value == "") {
    return "#FFFFFF";
  }
};

export const checkPositiveInteger = (num) => {
  let isRefresh = getStore({ name: "refresh-switch" });
  if (isRefresh == undefined || isRefresh == null) {
    setStore({ name: "refresh-switch", content: 1 });
    isRefresh = 1;
  }

  if (isRefresh == 1) {
    if (typeof num === "number" && Number.isInteger(num) && num > 0) {
      return num * 1000;
    }
    return 0;
  } 
  
  // 当 isRefresh 为 0 时返回 null 或 undefined
  return null;
};

export const getCustomTime = (value) => {
  let isRefresh = getStore({
    name: "refresh-switch",
  });
  if (isRefresh == undefined || isRefresh == null) {
    setStore({
      name: "refresh-switch",
      content: 1,
    });
    isRefresh=1
  }
  if (isRefresh == 1) {
    const customTime = refreshTime.custom.find((item) => item.id === value);
    if (customTime) {
      if (
        typeof customTime.timer === "number" &&
        Number.isInteger(customTime.timer) &&
        customTime.timer > 0
      ) {
        return customTime.timer * 1000; // 返回乘以1000的值
      } else {
        return 0;
      }
    } else {
      if (
        typeof refreshTime.common.timer === "number" &&
        Number.isInteger(refreshTime.common.timer) &&
        refreshTime.common.timer > 0
      ) {
        return refreshTime.common.timer * 1000; // 返回乘以1000的值
      } else {
        return 0;
      }
    }
  } else if (isRefresh == 0) {
    return null;
  }
};

/**
 * 解析 JWT payload（不校验签名，仅读取 payload 内容）
 * @param {string} token - 完整 JWT 字符串
 * @returns {Object|null} payload 对象，解析失败返回 null
 */
export const parseJwtPayload = (token) => {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.trim().split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

/**
 * 按业务 identifier 从大屏设备测点列表中取一行（与后端 devices[].identifier 对齐）
 * @param {Array} devices - 接口返回的 devices 数组
 * @param {string} identifier - 业务测点标识符
 * @param {number} [fallbackIndex] - 未配置 identifier 或未命中时回退的下标（兼容旧数据）
 * @returns {Object|null}
 */
export const deviceByIdentifier = (devices, identifier, fallbackIndex) => {
  const list = Array.isArray(devices) ? devices : [];
  const id = identifier != null ? String(identifier).trim() : "";
  if (id) {
    const hit = list.find(
      (d) => d && String(d.identifier || "").trim() === id
    );
    if (hit) {
      return hit;
    }
  }
  if (
    fallbackIndex != null &&
    Number.isInteger(fallbackIndex) &&
    fallbackIndex >= 0 &&
    list[fallbackIndex]
  ) {
    return list[fallbackIndex];
  }
  return null;
};